/**
 * QuotesOverTime Component
 *
 * Displays quotes over time line chart
 */

import { Typography } from 'antd';
import { format, parseISO } from 'date-fns';
import React, { useMemo } from 'react';
import {
  CartesianGrid,
  Line,
  LineChart,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import { useQuoteAverage } from '../hooks';

const { Title, Text } = Typography;

export const QuotesOverTime = ({ region }: { region?: number }) => {
  const { data: quoteAverageData } = useQuoteAverage(region);

  // Format quote average data for the chart
  const formattedData = useMemo(() => {
    if (!quoteAverageData?.breakdown) return [];

    return quoteAverageData.breakdown.map((item) => ({
      ...item,
      date: format(parseISO(item.date), 'MMM dd'),
    }));
  }, [quoteAverageData]);

  return (
    <div className="bg-white rounded-lg p-4 flex flex-col gap-3 shadow-none">
      <div>
        <Title level={5} className="!mb-1">
          Quotes Over Time
        </Title>
        <Text type="secondary" className="text-sm ">
          Number of quotes created in the last 30 days
        </Text>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={formattedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <RechartsTooltip />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#EF4444"
            strokeWidth={2}
            dot={{ fill: '#EF4444' }}
            name="Quotes"
          />
        </LineChart>
      </ResponsiveContainer>

    </div>
  );
};

export default QuotesOverTime;
